class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M11.249 3v2H2V3h9.249Zm0-1H2a.999.999 0 0 0-1 1v2a.997.997 0 0 0 1 1h9.249a.99.99 0 0 0 .705-.294A1 1 0 0 0 12.25 5V3a1.001 1.001 0 0 0-1-1ZM4 8v5H2V8h2Zm0-1H2a.999.999 0 0 0-1 1v5a.997.997 0 0 0 1 1h2a1 1 0 0 0 .706-.294A1 1 0 0 0 5 13V8a1.001 1.001 0 0 0-1-1Zm3 1v5h.749v1H7a1.001 1.001 0 0 1-1-1V8a.999.999 0 0 1 1-1h4.291a.999.999 0 0 1 1 1v.5h-1V8H7Zm8.351 2.146-1.5-1.5a.494.494 0 0 0-.542-.109.493.493 0 0 0-.163.109L8.5 13.29v2.21h2.206l4.645-4.649a.493.493 0 0 0 .109-.162.486.486 0 0 0 .04-.189.49.49 0 0 0-.04-.191.493.493 0 0 0-.109-.163Zm-5.06 4.354H9.5v-.794l2.5-2.5.791.794-2.5 2.5Zm3.209-3.209-.794-.791.794-.794.791.794-.791.791Z"></path></svg>';
  }
}
const a = "pi-mod-smartforms";
customElements.get(a) || customElements.define(a, s);
export {
  s as default
};
